<template>
  <div
    v-show="references.length"
    class="attachment-chips"
  >
    <div
      v-for="ref in references"
      :key="ref.id"
      class="attachment-chips__chip"
    >
      <img
        v-if="ref.kind === 'image' && ref.url"
        :src="ref.thumbnail_url || ref.url"
        :alt="ref.name"
        class="attachment-chips__thumb"
      >
      <i
        v-else
        class="bi attachment-chips__icon"
        :class="chipIcon(ref)"
      />
      <a
        :href="ref.url"
        :download="download ? ref.name : null"
        target="_blank"
        rel="noopener noreferrer"
        class="attachment-chips__name"
      >{{ ref.name }}</a>
    </div>
  </div>
</template>

<script>
import { referenceChipIconClass } from '@frontend/utils/fileAttachments';

export default {
  name: 'AttachmentChips',
  props: {
    references: { type: Array, default: () => [] },
    // Comment files are stored under a uuid, so the link has to carry the original name.
    download: { type: Boolean, default: false },
  },
  methods: {
    chipIcon: referenceChipIconClass,
  },
};
</script>

<style scoped>
.attachment-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 0.375rem;
  margin-top: 0.5rem;
}

.attachment-chips__chip {
  display: inline-flex;
  align-items: center;
  gap: 0.375rem;
  max-width: 100%;
  padding: 0.25rem 0.5rem;
  border: 1px solid hsl(214.3 31.8% 91.4%);
  border-radius: calc(0.375rem - 2px);
  background: hsl(0 0% 100%);
  font-size: 0.75rem;
  line-height: 1rem;
  color: hsl(222.2 47.4% 11.2%);
  text-decoration: none;
}

.attachment-chips__chip:hover {
  border-color: hsl(215.4 16.3% 46.9% / 0.4);
}

.attachment-chips__icon {
  flex-shrink: 0;
  font-size: 0.875rem;
  color: hsl(215.4 16.3% 46.9%);
}

.attachment-chips__thumb {
  flex-shrink: 0;
  width: 1.25rem;
  height: 1.25rem;
  object-fit: cover;
  border-radius: calc(0.375rem - 3px);
}

.attachment-chips__name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 14rem;
  color: inherit;
  text-decoration: none;
}

.attachment-chips__name:hover {
  text-decoration: underline;
}
</style>
